import React from 'react'
import { timelineTimeToSeconds } from 'Util'
import { TimeCodeContainerLocationType } from 'types/timecode'
import { PlayerType } from 'types/common'
import { useSliderTime } from 'providers/SliderTimeContextProvider'
import { TimeCodeContainer } from './TimeCodeContainer'

interface IProps {
  progress?: number
  containerLocation: TimeCodeContainerLocationType // <Component>, example <Preview>
  onRewind?(sec: number): void
  onMoveSlider?(unitSec: number): void
  fps?: number
  previewPlayerType?: PlayerType,
  readonly?: boolean,
  isTimelineTime?: boolean
  startTime: number
  isMedia: boolean
}

export const TimeCode:React.FC<IProps> = React.memo(props => {
  const localTime = useSliderTime()
  return (
    <TimeCodeContainer
      {...props}
      progress={props.progress ?? timelineTimeToSeconds(localTime)}
    />
  )
})
